export const LOGOUT = 'LOGOUT';

export const logout = () => (dispatch: any) => {
  dispatch({type: LOGOUT});
};
